// @flow
import * as React from 'react';
import Loadable from 'react-loadable';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "SaveListingModalContainer" */ './SaveListingModalContainer'),
  loading: () => <div />
});
